import { ColorTypes } from "../../public/charting_library/charting_library";

export const getOverrides = (theme_: string) => {
  return {
    "paneProperties.backgroundType": "solid" as ColorTypes,
    "paneProperties.background": theme_ === "dark" ? "#070D10" : "#fff",
    "scalesProperties.textColor": theme_ === "dark" ? "#999" : "#1c1c1c",
    "paneProperties.legendProperties.showBackground": false,
    "mainSeriesProperties.priceLineColor":
      theme_ === "dark" ? "#960000" : "#960000",
    "mainSeriesProperties.candleStyle.downColor": "#960000",
    "mainSeriesProperties.candleStyle.borderDownColor": "#960000",
    "mainSeriesProperties.candleStyle.wickDownColor": "#960000",
    "mainSeriesProperties.hollowCandleStyle.borderDownColor": "#960000",
    "mainSeriesProperties.hollowCandleStyle.downColor": "#960000",
    "mainSeriesProperties.hollowCandleStyle.wickDownColor": "#960000",
    "mainSeriesProperties.haStyle.downColor": "#960000",
    "mainSeriesProperties.haStyle.borderDownColor": "#960000",
    "mainSeriesProperties.haStyle.wickDownColor": "#960000",
    "mainSeriesProperties.barStyle.downColor": "#960000",
    "mainSeriesProperties.lineStyle.color":
      theme_ === "dark" ? "#03E4BA" : "#0a6f6f",
    "mainSeriesProperties.candleStyle.upColor":
      theme_ === "dark" ? "#03E4BA" : "#0a6f6f",
    "mainSeriesProperties.candleStyle.borderUpColor":
      theme_ === "dark" ? "#03E4BA" : "#0a6f6f",
    "mainSeriesProperties.candleStyle.wickUpColor":
      theme_ === "dark" ? "#03E4BA" : "#0a6f6f",
    "mainSeriesProperties.hollowCandleStyle.upColor":
      theme_ === "dark" ? "#03E4BA" : "#0a6f6f",
    "mainSeriesProperties.hollowCandleStyle.wickUpColor":
      theme_ === "dark" ? "#03E4BA" : "#0a6f6f",
    "mainSeriesProperties.haStyle.upColor":
      theme_ === "dark" ? "#03E4BA" : "#0a6f6f",
    "mainSeriesProperties.haStyle.borderUpColor":
      theme_ === "dark" ? "#03E4BA" : "#0a6f6f",
    "mainSeriesProperties.haStyle.wickUpColor":
      theme_ === "dark" ? "#03E4BA" : "#0a6f6f",
    "mainSeriesProperties.barStyle.upColor":
      theme_ === "dark" ? "#03E4BA" : "#0a6f6f",
    "mainSeriesProperties.hlcAreaStyle.highLineColor":
      theme_ === "dark" ? "#03E4BA" : "#0a6f6f",
    "mainSeriesProperties.renkoStyle.upColor":
      theme_ === "dark" ? "#03E4BA" : "#0a6f6f",
    "mainSeriesProperties.renkoStyle.borderUpColor":
      theme_ === "dark" ? "#03E4BA" : "#0a6f6f",
    "mainSeriesProperties.pbStyle.upColor":
      theme_ === "dark" ? "#03E4BA" : "#0a6f6f",
    "mainSeriesProperties.pbStyle.borderUpColor":
      theme_ === "dark" ? "#03E4BA" : "#0a6f6f",
    "mainSeriesProperties.kagiStyle.upColor":
      theme_ === "dark" ? "#03E4BA" : "#0a6f6f",
    "mainSeriesProperties.pnfStyle.upColor":
      theme_ === "dark" ? "#03E4BA" : "#0a6f6f",
    "mainSeriesProperties.baselineStyle.topLineColor":
      theme_ === "dark" ? "#03E4BA" : "#0a6f6f",
    "linetooldisjointangle.linecolor":
      theme_ === "dark" ? "#03E4BA" : "#0a6f6f",
    "linetooldisjointangle.textcolor":
      theme_ === "dark" ? "#03E4BA" : "#0a6f6f",
    "linetoolfibchannel.level16.color":
      theme_ === "dark" ? "#03E4BA" : "#0a6f6f",
    "linetoolfibchannel.level24.color":
      theme_ === "dark" ? "#03E4BA" : "#0a6f6f",
    "linetoolfibchannel.level5.color":
      theme_ === "dark" ? "#03E4BA" : "#0a6f6f",
    "linetoolfibcircles.level3.color":
      theme_ === "dark" ? "#03E4BA" : "#0a6f6f",
    "linetoolfibretracement.level16.color":
      theme_ === "dark" ? "#03E4BA" : "#0a6f6f",
    "linetoolfibretracement.level24.color":
      theme_ === "dark" ? "#03E4BA" : "#0a6f6f",
    "linetoolfibretracement.level5.color":
      theme_ === "dark" ? "#03E4BA" : "#0a6f6f",
    "linetoolfibspeedresistancearcs.level3.color":
      theme_ === "dark" ? "#03E4BA" : "#0a6f6f",
    "linetoolfibspeedresistancefan.hlevel5.color":
      theme_ === "dark" ? "#03E4BA" : "#0a6f6f",
    "linetoolfibspeedresistancefan.vlevel5.color":
      theme_ === "dark" ? "#03E4BA" : "#0a6f6f",
    "linetoolfibwedge.level4.color": theme_ === "dark" ? "#03E4BA" : "#0a6f6f",
    "linetoolganncomplex.arcs.7.color":
      theme_ === "dark" ? "#03E4BA" : "#0a6f6f",
    "linetoolganncomplex.arcs.8.color":
      theme_ === "dark" ? "#03E4BA" : "#0a6f6f",
    "linetoolganncomplex.fanlines.6.color":
      theme_ === "dark" ? "#03E4BA" : "#0a6f6f",
    "linetoolganncomplex.fanlines.7.color":
      theme_ === "dark" ? "#03E4BA" : "#0a6f6f",
    "linetoolganncomplex.levels.4.color":
      theme_ === "dark" ? "#03E4BA" : "#0a6f6f",
    "linetoolgannfan.level2.color": theme_ === "dark" ? "#03E4BA" : "#0a6f6f",
    "linetoolgannfan.level4.color": theme_ === "dark" ? "#03E4BA" : "#0a6f6f",
    "linetoolgannfixed.arcs.7.color": theme_ === "dark" ? "#03E4BA" : "#0a6f6f",
    "linetoolgannfixed.arcs.8.color": theme_ === "dark" ? "#03E4BA" : "#0a6f6f",
    "linetoolgannfixed.fanlines.6.color":
      theme_ === "dark" ? "#03E4BA" : "#0a6f6f",
    "linetoolgannfixed.fanlines.7.color":
      theme_ === "dark" ? "#03E4BA" : "#0a6f6f",
    "linetoolgannfixed.levels.4.color":
      theme_ === "dark" ? "#03E4BA" : "#0a6f6f",
    "linetoolgannsquare.hlevel5.color":
      theme_ === "dark" ? "#03E4BA" : "#0a6f6f",
    "linetoolgannsquare.vlevel5.color":
      theme_ === "dark" ? "#03E4BA" : "#0a6f6f",
    "linetoolghostfeed.candleStyle.borderUpColor":
      theme_ === "dark" ? "#03E4BA" : "#0a6f6f",
    "linetoolheadandshoulders.backgroundColor":
      theme_ === "dark" ? "#03E4BA" : "#0a6f6f",
    "linetoolheadandshoulders.color": theme_ === "dark" ? "#03E4BA" : "#0a6f6f",
    "linetoolinsidepitchfork.level2.color":
      theme_ === "dark" ? "#03E4BA" : "#0a6f6f",
    "linetoolinsidepitchfork.level3.color":
      theme_ === "dark" ? "#03E4BA" : "#0a6f6f",
    "linetoolpitchfan.level3.color": theme_ === "dark" ? "#03E4BA" : "#0a6f6f",
    "linetoolpitchfork.level2.color": theme_ === "dark" ? "#03E4BA" : "#0a6f6f",
    "linetoolpitchfork.level3.color": theme_ === "dark" ? "#03E4BA" : "#0a6f6f",
    "linetoolschiffpitchfork2.level2.color":
      theme_ === "dark" ? "#03E4BA" : "#0a6f6f",
    "linetoolschiffpitchfork2.level3.color":
      theme_ === "dark" ? "#03E4BA" : "#0a6f6f",
    "linetoolschiffpitchfork.level2.color":
      theme_ === "dark" ? "#03E4BA" : "#0a6f6f",
    "linetoolschiffpitchfork.level3.color":
      theme_ === "dark" ? "#03E4BA" : "#0a6f6f",
    "linetooltrendbasedfibextension.level16.color":
      theme_ === "dark" ? "#03E4BA" : "#0a6f6f",
    "linetooltrendbasedfibextension.level24.color":
      theme_ === "dark" ? "#03E4BA" : "#0a6f6f",
    "linetooltrendbasedfibextension.level5.color":
      theme_ === "dark" ? "#03E4BA" : "#0a6f6f",
    "linetooltrendbasedfibtime.level5.color":
      theme_ === "dark" ? "#03E4BA" : "#0a6f6f",
    "linetooltriangle.color": theme_ === "dark" ? "#03E4BA" : "#0a6f6f",
    "linetoolabcd.color": theme_ === "dark" ? "#03E4BA" : "#0a6f6f",
    "linetoolarrowmarkup.arrowColor": theme_ === "dark" ? "#03E4BA" : "#0a6f6f",
    "linetoolarrowmarkup.color": theme_ === "dark" ? "#03E4BA" : "#0a6f6f",
    "mainSeriesProperties.hollowCandleStyle.borderUpColor":
      theme_ === "dark" ? "#03E4BA" : "#0a6f6f",
    "paneProperties.vertGridProperties.color":
      theme_ === "dark" ? "#070D10" : "#fff",
    "paneProperties.horzGridProperties.color":
      theme_ === "dark" ? "#070D10" : "#fff",
    "scalesProperties.lineColor": theme_ === "dark" ? "#070D10" : "#fff",
    "scalesProperties.fontSize": 9,
    "mainSeriesProperties.areaStyle.color1":
      theme_ === "dark" ? "#03E4BA" : "#0a6f6f",
    "mainSeriesProperties.areaStyle.color2":
      theme_ === "dark" ? "#070D10" : "#fff",
    "mainSeriesProperties.areaStyle.linecolor":
      theme_ === "dark" ? "#03E4BA" : "#0a6f6f",
    "mainSeriesProperties.areaStyle.transparency": 70,
  };
};
